<template>
  <v-container id="inventories" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/inventory/create'">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Purchase Start Date')"
                class="purple-input"
                v-model="filter.p_startDate"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Purchase End Date')"
                class="purple-input"
                v-model="filter.p_endDate"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Expiry Start Date')"
                class="purple-input"
                v-model="filter.e_startDate"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Expiry End Date')"
                class="purple-input"
                v-model="filter.e_endDate"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <v-autocomplete
                :label="$i18n.t('Article')"
                class="purple-input"
                v-model="filter.article_id"
                :items="articleList"
                item-text="name"
                item-value="_id"
                clearable
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <z-driver-select
                idOnly
                clearable
                class="purple-input"
                v-model="filter.driver_id"
              ></z-driver-select>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <v-text-field
                :label="$i18n.t('Bill No.')"
                class="purple-input"
                v-model="filter.billNo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <v-checkbox
                :label="$i18n.t('All Consumed')"
                class="form-control"
                v-model="filter.allConsumed"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <v-checkbox
                :label="$i18n.t('Zero Consumed')"
                class="form-control"
                v-model="filter.zeroConsumed"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Inventories')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th>
                {{ $i18n.t("Article") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Bill No") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Purchased") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Expiry") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Units") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Available") }}
              </th>
              <th class="text-center">
                {{ $i18n.t("Consumption") }}
              </th>
              <th class="text-right">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <inventory-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @reload="reload"
            :refresh="refresh"
          />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import InventoryRow from "@/views/articleinventory/InventoryRow.vue";

@Component({
  name: "Inventories",
  components: { InventoryRow },
})
export default class Inventories extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/article/inventory/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  filter = {
    p_startDate: null,
    p_endDate: null,
    e_startDate: null,
    e_endDate: null,
    article_id: null,
    driver_id: null,
    billNo: null,
    allConsumed: null,
    zeroConsumed: null,
  };

  get loading() {
    return common.loading;
  }

  articleList = [];
  async fetchArticleList() {
    this.articleList = await doGet("/api/article/list");
  }

  async mounted() {
    this.fetchArticleList();
    this.showPage(1);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      p_startDate: null,
      p_endDate: null,
      e_startDate: null,
      e_endDate: null,
      article_id: null,
      driver_id: null,
      billNo: null,
      allConsumed: null,
      zeroConsumed: null,
    };

    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";

    if (
      this.filter.p_startDate &&
      this.filter.p_endDate &&
      this.filter.p_startDate > this.filter.p_endDate
    ) {
      common.setError("Purchase start time is greater than end time");
      return;
    }

    if (
      this.filter.e_startDate &&
      this.filter.e_endDate &&
      this.filter.e_startDate > this.filter.e_endDate
    ) {
      common.setError("Expire start time is greater than end time");
      return;
    }

    if (this.filter.p_startDate)
      this.filterUrl += "&p_startDate=" + this.filter.p_startDate;
    if (this.filter.p_endDate)
      this.filterUrl += "&p_endDate=" + this.filter.p_endDate;
    if (this.filter.e_startDate)
      this.filterUrl += "&e_startDate=" + this.filter.e_startDate;
    if (this.filter.e_endDate)
      this.filterUrl += "&e_endDate=" + this.filter.e_endDate;

    if (this.filter.article_id)
      this.filterUrl += "&article_id=" + this.filter.article_id;
    if (this.filter.driver_id)
      this.filterUrl += "&driver_id=" + this.filter.driver_id;
    if (this.filter.billNo) this.filterUrl += "&billNo=" + this.filter.billNo;
    if (this.filter.allConsumed) this.filterUrl += "&allConsumed=true";
    if (this.filter.zeroConsumed) this.filterUrl += "&zeroConsumed=true";
    common.setLoading(true);
    await this.showPage(1);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }

  closeDialog() {
    this.showBulkUpdateDialog = false;
    this.payload = {};
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
tbody:nth-child(even) {
  background: #fafafa;
}
</style>
